<template>
	<Panel id="reset-password" :panel-identifier="'reset-password'" :height="450">
		<template #panel-content>
            <div class="container">
                <div class="header" :lang="this.$i18n.locale">
					{{ $t('reset_password.reset_password') }}
				</div>
                <div class="input-container" v-show="!passwordWasReset">
                    <div class="password-container" :lang="this.$i18n.locale">
                        {{ $t('reset_password.new_password') }} 
                        <div class="requirements"> {{ $t('reset_password.password_requirement') }} </div>
						<input type="password" id="password" :lang="this.$i18n.locale" v-model="newPassword"/>
                        {{ $t('reset_password.confirm_password') }}
						<input type="password" id="confirm-password" :lang="this.$i18n.locale" v-model="newPasswordConfirmation"/>
                        <div class="error" v-show="resetPasswordError.length">
                            {{ $t(resetPasswordError) }}
                        </div>
                    </div>
                </div>
                <div class="password-changed-container" v-show="passwordWasReset" :lang="this.$i18n.locale">
                    {{ $t('reset_password.password_was_changed') }}
                </div>
                <div class="button-container" v-show="!passwordWasReset">
					<TextButton :button-label="$t('reset_password.set_password')" :button-style="'blue'" @on-click-fn="() => { sendResetPassword( {newPassword, newPasswordConfirmation}) }" :disabled="sendingReset" :loading="sendingReset"></TextButton>
                </div>
                <div class="button-container" v-show="passwordWasReset">
					<TextButton :button-label="$t('reset_password.back')" :button-style="'blue'" @on-click-fn="goBack" :disabled="sendingReset" :loading="sendingReset"></TextButton>
                </div>
            </div>
        </template>
    </Panel>
</template>

<script lang="ts">
import { mapActions, mapState, mapMutations } from 'vuex'
import Panel from '../ui-components/panel/panel.vue'
import TextButton from '../ui-components/buttons/text-button.vue'
import { Views } from '../store/ui-store'

export default {
    name: 'ResetPassword',
    components: {
        Panel,
        TextButton
    },
    data() {
        return {
            newPassword: '',
            newPasswordConfirmation: ''
        }
    },
    computed: {
        ...mapState('user', ['resetPasswordError', 'sendingSetPassword', 'passwordWasReset'])
    },
    methods: {
        ...mapActions('user', ['sendResetPassword']),
        ...mapMutations('user', ['backFromResetPassword']),
        ...mapMutations('ui', ['setActiveView']),
        goBack() {
            this.setActiveView(Views.LANDING)
        }
    },
}
</script>

<style lang="less" scoped>
@import url('../../web/global/fonts/fonts.less');

#reset-password {
    width: 600px;
    display: flex;
    flex-direction: column;
	align-items: center;

    .container {
        .header {
            color: @cream;
			text-align: center;
			margin-bottom: 10px;
			&[lang='en'] {
				.regularFont(@enRegularFontPixl);
				font-variant: small-caps;
				font-size: 50px;
			}

			&[lang='zh'] {
				.regularFont(@zhHansHeaderFont);
			}
        }

        .password-container {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;

            color: @offWhite;

            &[lang='en'] {
                .regularFont(@enRegularFontPixl);
                font-size: 30px;
            }

            &[lang='zh'] {
                .regularFont(@zhHansHeaderFont);
            }

            .requirements {
                font-size: 24px;
            }

            input {
				outline: none;
				height: 35px;
				border: 0px solid red;
				width: 400px;
				background-color: #040e26 !important;
				font-size: 18px;
				color: @darkGreen;
				margin-bottom: 10px;
                margin-top: 10px;
				
                &[lang='en'] {
					.regularFont(@enSecondaryFontPTBold);
					font-size: 24px;
				}
				&[lang='zh'] {
					.regularFont(@zhHansHeaderFont);
					font-size: 24px;
				}
				&.error {
					border: 2px solid red;
					border-radius: 2px;
					filter: drop-shadow(0px 0px 2px red);
				}
			}

            .error {
                color: @red;
                font-size: 24px;
            }
        }

        .button-container {
            width: 100%;
            display: flex;
	        align-items: center;
            justify-content: center;
            margin-top: 20px;
        }

        .password-changed-container {
            color: @offWhite;
            text-align: center;

            &[lang='en'] {
                .regularFont(@enRegularFontPixl);
                font-size: 30px;
            }

            &[lang='zh'] {
                .regularFont(@zhHansHeaderFont);
            }
        }
    }
}
</style>